import i18next from "i18next";

const getContainerStatusString = (status: number, t: any): string => {
    const statusKey = `containers.status.${status}`;
    const result = t(statusKey);

    if (result === statusKey) {
        return t("containers.status.default") as string;
    }

    return result as string;
};

export const ContainerStatusToString = (status: number): string => {
    return getContainerStatusString(status, (key: string) => i18next.t(key, { ns: "admin" }));
};